const responsiveImageWidths = [240, 480, 800, 1200] as const;

export function getHomeOrbitSrcset(src: string) {
  if (!/^\/images\/ai-retouching\/composite-(product-|model-final)/.test(src)) return undefined;
  return [240, 480, 800].map((width) => `${src.replace(/\.webp$/, `-${width}.webp`)} ${width}w`).join(", ");
}

export function getRemoteImageSrcset(src: string) {
  let url: URL;

  try {
    url = new URL(src);
  } catch {
    return undefined;
  }

  const supportsWidthTransform =
    url.hostname === "images.pexels.com" ||
    url.hostname === "images.unsplash.com";

  if (!supportsWidthTransform) return undefined;

  return responsiveImageWidths
    .map((width) => {
      const candidate = new URL(url);
      candidate.searchParams.set("w", String(width));
      if (candidate.hostname === "images.unsplash.com") {
        candidate.searchParams.set("q", "80");
      }
      return `${candidate.toString()} ${width}w`;
    })
    .join(", ");
}
